import React from "react";
import Container from "src/components/atoms/Container";
import PageHeading from "src/components/molecules/PageHeading";
import Pagination from "src/components/molecules/Pagination";
import CourseList from "src/components/organisms/Courses/CourseList";
import { PaginationProvider } from "src/contexts/PaginationContext";
import { getCourses } from "src/services/DefaultService";

const Courses: React.FC<{ home: any }> = ({ home }) => {
  const { attributes } = home;
  return (
    <Container className="mb-16">
      <PaginationProvider queryKey={"getCourses"} queryFunction={getCourses}>
        <PageHeading
          title={attributes.title}
          description={attributes.subTitle}
        />
        <CourseList />
        <div className="mt-10">
          <Pagination />
        </div>
      </PaginationProvider>
    </Container>
  );
};

export default Courses;
